import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Grid, InputAdornment, Box, IconButton, Tooltip } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { AutoCompleteSelectUI, DatePickerUI, FormErrorUI, FormLabelUI, InputUI, SelectUI } from '../Interface';

const SettlementFields = (props) => {
  const { remove, autocompleteOptions } = props;
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    values?.settlement?.length > 0 &&
    values.settlement.map((sttl, index) => (
      <Box
        key={index}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          p: 2,
          mb: 2,
          backgroundColor: 'background.paper',
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Grid container spacing={2}>
            <Grid item xs={8} sx={{ fontWeight: 600, color: 'text.secondary' }}>
              {`Tétel ${index + 1}`}
            </Grid>
            <Grid item xs={4} display="flex" justifyContent="flex-end">
              <Tooltip title="Sor törlése">
                <IconButton size="small" color="error" onClick={() => remove?.(index)}>
                  <DeleteOutlineIcon /> Törlés
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Field
              type="number"
              name={`settlement.${index}.amount`}
              as={InputUI}
              fullWidth
              label={<FormLabelUI text="Összeg" />}
              variant="standard"
              InputProps={{ endAdornment: <InputAdornment position="end">{values.currencyCode}</InputAdornment> }}
              helperText={<FormErrorUI message={errors?.settlement?.[index]?.amount} />}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Field
              name={`settlement.${index}.mode`}
              component={SelectUI}
              fullWidth
              option={autocompleteOptions?.settlementMode ?? []}
              value={sttl.mode ?? ''}
              variant="standard"
              onChange={(e) => {
                setFieldValue(`settlement.${index}.mode`, e.target.value ?? null).then(() => {
                  validateField(`settlement.${index}.mode`);
                });
              }}
              label={<FormLabelUI text="Kiegyenlítés módja" />}
              helperText={<FormErrorUI message={errors?.settlement?.[index]?.mode} />}
              InputLabelProps={{ shrink: sttl.mode !== '' }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Field
              type="date"
              name={`settlement.${index}.date`}
              component={DatePickerUI}
              value={sttl.date}
              fullWidth
              label={<FormLabelUI text="Dátum" />}
              variant="standard"
              helperText={<FormErrorUI message={errors?.settlement?.[index]?.date} />}
              onChange={(date) => {
                setFieldValue(`settlement.${index}.date`, date).then(() => {
                  validateField(`settlement.${index}.date`);
                });
              }}
              InputLabelProps={{ shrink: sttl.date !== '' }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Field
              name={`settlement.${index}.bankAccountId`}
              component={AutoCompleteSelectUI}
              fullWidth
              dataset={autocompleteOptions?.bankAccount ?? []}
              selectedValue={sttl.bankAccountId}
              variant="standard"
              onChange={(_e, newVal) => {
                setFieldValue(`settlement.${index}.bankAccountId`, newVal?.value ?? null);
              }}
              label={<FormLabelUI text="Bankszámla" />}
              InputLabelProps={{ shrink: Boolean(sttl.bankAccountId) }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Field
              type="text"
              name={`settlement.${index}.statementNumber`}
              as={InputUI}
              fullWidth
              label={<FormLabelUI text="Kivonat sorszáma" />}
              variant="standard"
              InputLabelProps={{ shrink: Boolean(sttl.statementNumber) }}
            />
          </Grid>
        </Grid>
      </Box>
    ))
  );
};

export default SettlementFields;
